export const productData = (product, isModal = false) => ({
  product,
  options: product.options,
  selectedVariants: [product.firstAvailableOrSelectedVariant],
  selectedOptions: Object.fromEntries(
    product.firstAvailableOrSelectedVariant.selectedOptions.map((option) => [option.name, option.value]),
  ),
  isWorking: false,
  drawerSide: '',

  get optionsWithState() {
    const { options, selectedOptions, product } = this;

    return options.map((option) => {
      const { name, values } = option;
      return {
        name,
        values: values.map((value) => {
          const newSelectedOptions = { ...selectedOptions };
          delete newSelectedOptions[name];
          const newSelectedOptionsArray = [[name, value], ...Object.entries(newSelectedOptions)];
          const { availableVariants } = this.calculateOptionsAndVariants(newSelectedOptionsArray);
          const swatches = product.variants.find((v) => v.title.includes(value));
          const variant_image = swatches && swatches?.image ? swatches?.image?.url : null;

          return {
            value,
            variant_image,
            variants: availableVariants.length,
            variantsInStock: availableVariants.filter((variant) => variant.availableForSale).length,
            hideVariant: availableVariants[0]?.metafield?.hideVariant ? true : false,
            media_id: availableVariants[0]?.media_id,
          };
        }),
      };
    });
  },

  // coming-soon, many-variants, sold-out-permanently, sold-out-notify, available
  get stateBase() {
    const { availableForSale } = product;
    

    // if (!availableForSale) {
    //   return `sold-out-permanently`;
    // }

    const { selectedVariants } = this;
    const [selectedVariant] = selectedVariants;

     // Check if product has back_in_stock tag and variant has low inventory
    const hasBackInStockTag = this.product.tags.includes('back_in_stock');
    const isLowInventory = selectedVariant.inventoryQuantity < 100;

    if (hasBackInStockTag && isLowInventory) {
      
      return 'back-in-stock';
    }

    if (!selectedVariant.availableForSale) {
      return `sold-out-permanently`;
    }

    if (selectedVariant.metafield?.hideVariant) {
      return `sold-out-permanently`;
    }


    return 'available';
  },

  init() {
    this.handleInitialVariantSlide();
  },

  get buttonLabelBase() {
    if (this.isWorking) return 'Adding…';

    const { stateBase } = this;

    switch (stateBase) {
      case 'sold-out-permanently':
        return 'Sold Out';
      case 'available':
        return 'Add to Bag';
      case 'back-in-stock':
        return 'Notify me when back in stock';
      default:
        return '';
    }
  },

   get isButtonDisabled() {
    // Only disable the button if it's sold out permanently
    const { stateBase } = this;
    return stateBase === 'sold-out-permanently';
  },

  klaviyoBISForm() {

      Alpine.store('quickBuyModal')?.hide();
      if (document.getElementById('klaviyo-bis-modal')) return;

      const title = this.product.title;
      const lowStockVariants = this.product.variants.filter(variant => variant.inventoryQuantity < 100);
      const hasMultipleVariants = lowStockVariants.length > 1;
      const defaultVariantId = lowStockVariants.length > 0 ? lowStockVariants[0].id : '';

      const modal = document.createElement('div');
      modal.id = 'klaviyo-bis-modal';
      modal.innerHTML = `
        <div id="klaviyo-overlay" class='fixed inset-0 bg-p-forest/70 flex justify-center items-center transition-opacity duration-300 ease-in-out z-30'>
          <div class='bg-white p-6 rounded-lg shadow-lg w-96 min-w-[400px] relative' id="klaviyo-content">
            <button id='klaviyo-close' class=' text-[25px] absolute top-3 right-3 text-gray-800 hover:text-gray-700'>&times;</button>
            <h2 class='text-xl font-semibold text-gray-900 mb-1'>${title}</h2>
            <p class="text-base mb-4">Register to receive a notification when this item comes back in stock.</p>
            ${hasMultipleVariants ? `
              <label class='block mb-2 text-gray-800 font-bold text-sm'>Select Variant:</label>
              <select id='klaviyo-variant' class='border pt-2 px-3  w-full rounded-full  mb-4'>
                ${lowStockVariants.map(variant => `
                  <option value="${variant.id}" ${variant.id === this.selectedVariants[0].id ? 'selected' : ''}>
                    ${variant.title}
                  </option>
                `).join('')}
              </select>` : ''}
            <label class='block mb-2 text-gray-800 font-bold text-sm'>Enter your email:</label>
            <input type='email' id='klaviyo-email' class='border pt-2 px-3 w-full rounded-full  focus:ring focus:ring-green-300' required />
            <p id='klaviyo-error' class='text-red-900 text-sm mt-1 hidden'>Please enter a valid email.</p>
            <button id='klaviyo-submit' class='bg-green-800 text-white w-full mt-4 py-3 rounded-full  hover:bg-green-700 transition font-bold uppercase text-sm tracking-[.1em]'>Notify me when back in stock</button>
            <p id='klaviyo-success' class='text-green-600 mt-2 hidden text-sm'>Thank you! You will be notified.</p>
          </div>
        </div>`;

      document.body.appendChild(modal);

      const closeModal = () => {
          document.body.removeChild(modal);
      };

      document.getElementById('klaviyo-close').addEventListener('click', closeModal);

      document.getElementById('klaviyo-overlay').addEventListener('click', (event) => {
          if (!document.getElementById('klaviyo-content').contains(event.target)) {
              closeModal();
          }
      });

      document.getElementById('klaviyo-submit').addEventListener('click', async () => {
          const emailField = document.getElementById('klaviyo-email');
          const errorMsg = document.getElementById('klaviyo-error');
          const successMsg = document.getElementById('klaviyo-success');
          const variantId = hasMultipleVariants ? document.getElementById('klaviyo-variant').value : defaultVariantId;
          
          if (!emailField.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailField.value)) {
              errorMsg.classList.remove('hidden');
              return;
          }

          errorMsg.classList.add('hidden'); // Hide error if email is valid

          const payload = {
              data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                      profile: { data: { type: 'profile', attributes: { email: emailField.value } } },
                      channels: ['EMAIL']
                  },
                  relationships: {
                      variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } }
                  }
              }
          };

          try {
              const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=PqM29e', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'REVISION': '2024-02-15' // Ensure correct Klaviyo API version
                  },
                  body: JSON.stringify(payload)
              });

              if (!response.ok) throw new Error('Failed to subscribe');

              successMsg.classList.remove('hidden');
              setTimeout(closeModal, 3000); // Close the modal after 3 seconds
          } catch (error) {
              errorMsg.textContent = 'Error: ' + error.message;
              errorMsg.classList.remove('hidden');
          }
      });
  },


  calculateOptionsAndVariants(selectedOptionsArray) {
    let availableVariants = product.variants;
    const correctSelectedOptions = {};
    for (const [name, value] of selectedOptionsArray) {
      const previousVariants = availableVariants;
      availableVariants = availableVariants.filter((variant) =>
        variant.selectedOptions.some((option) => option.name === name && option.value === value),
      );

      if (availableVariants.length === 0) {
        availableVariants = previousVariants;

        const newValue = availableVariants[0].selectedOptions.find((option) => option.name === name).value;
        correctSelectedOptions[name] = newValue;
        availableVariants = availableVariants.filter((variant) =>
          variant.selectedOptions.some((option) => option.name === name && option.value === newValue),
        );
      } else {
        correctSelectedOptions[name] = value;
      }
    }

    return { availableVariants, correctSelectedOptions };
  },

  normalizeOptionsAndVariants(selectedOptionsArray) {
    const { availableVariants, correctSelectedOptions } = this.calculateOptionsAndVariants(selectedOptionsArray);
    this.selectedOptions = correctSelectedOptions;
    this.selectedVariants = availableVariants;
  },

  handleInitialVariantSlide() {
    const currentVariant = product.firstAvailableOrSelectedVariant;
    if (currentVariant && currentVariant.media_id) {
      const media_id = currentVariant.media_id;
      setTimeout(() => {
        this.$dispatch('hero-product-variant-slide', { media_id });
      }, 100);
    }
  },

  handleOptionChange(name, value, media_id) {
    const newSelectedOptions = { ...this.selectedOptions };
    delete newSelectedOptions[name];
    const newSelectedOptionsArray = [[name, value], ...Object.entries(newSelectedOptions)];
    this.normalizeOptionsAndVariants(newSelectedOptionsArray);

    if (media_id) {
      this.$dispatch('hero-product-variant-slide', { media_id });
    }
  },

  async addToCart() {
    if (this.isWorking) return;
    const { selectedVariants } = this;
    const [selectedVariant] = selectedVariants;
    const simpleId =
      typeof selectedVariant.id === 'number'
        ? selectedVariant.id
        : Number(selectedVariant.id.split('gid://shopify/ProductVariant/')[1]);

    const payload = {
      items: [
        {
          id: simpleId,
          selling_plan: this.purchaseType === 'one-time' ? null : this.sellingPlanId,
          ...(Object.hasOwn(this.product, 'hazardous_metafield') && {
            properties: {
              _hazardous_product_title: this.product.hazardous_metafield?.notificationTitle,
              _hazardous_product_content: this.product.hazardous_metafield?.notificationContent,
            },
          }),
        },
      ],
    };

    try {
      this.isWorking = true;

      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'post',
        body: JSON.stringify(payload),
        headers: { 'content-type': 'application/json' },
      });

      if (!res.ok) {
        let description = '';
        try {
          const data = await res.json();
          description = data?.description;
        } catch (e) {
          //
        }
        throw new Error([`Failed to add to bag!`, description, `(status: ${res.status})`].filter(Boolean).join('\n'));
      }
    } catch (error) {
      alert(error.message);
      this.isWorking = false;
      throw error;
    }
  },
});